import { stepMedicalAndEvacuationLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
      ? data.whatExpensesAreYouClaimingFor.toJS()
      : data.whatExpensesAreYouClaimingFor || [];
  const medicalExpenses = expensesSelected.includes('Medical & Hospital Expenses') ? mapToOtherExpenses(data) : [];
  const dentalExpenses = expensesSelected.includes('Dental Expenses') ? mapToDentalExpenses(data) : [];
  const funeralExpenses = expensesSelected.includes('Funeral Expenses') ? mapToFuneralExpenses(data) : [];
  const expensesArisingFromTerrorism = expensesSelected.includes('Expenses arising from terrorism') ? mapToExpensesArisingFromTerrorism(data) : [];
  return [...medicalExpenses, ...dentalExpenses, ...funeralExpenses, ...expensesArisingFromTerrorism];
}

function mapToOtherExpenses(data) {
  if (data.infoMedicalExpensesHospitalisedItems.length < 1 &&
    data.infoMedicalExpensesItems.length < 1 &&
    data.infoMedicalExpensesCompanionItems.length < 1 &&
    data.infoOpticalTreatmentItems.length < 1 &&
    data.infoAncillaryServicesItems.length < 1 &&
    data.infoMentalHealthItems.length < 1 &&
    data.infoSexualHealthItems.length < 1 &&
    data.infoExtraTravelAndAccommodationItems.length < 1 &&
    data.infoSearchAndRescueItems.length < 1 &&
    data.infoUrgentCareOutOfHoursVisitsItems.length < 1 &&
    data.infoPrescriptionsItems.length < 1 &&
    data.infoGPVisitsItems.length < 1 &&
    data.infoRehabilitationAndOccupationalTherapyItems.length < 1 &&
    data.infoMaternityCareItems.length < 1 &&
    data.infoReplacementStaffItems.length < 1 &&
    data.infoRepatriationBenefitItems.length < 1 &&
    data.infoOtherMedicalExpensesItems.length < 1) {
    return [];
  }

  const expenses = [];
  let claimCode = expenseLookup.medicalHospitalExpenses.claimCode;
  if (data.infoMedicalExpensesItems.length > 0) {
    claimCode = expenseLookup.medicalHospitalExpenses.claimCode;
    data.infoMedicalExpensesItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoOpticalTreatmentItems.length > 0) {
    claimCode = expenseLookup.opticalTreatment.claimCode;
    data.infoOpticalTreatmentItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoAncillaryServicesItems.length > 0) {
    claimCode = expenseLookup.ancillaryServices.claimCode;
    data.infoAncillaryServicesItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoMentalHealthItems.length > 0) {
    claimCode = expenseLookup.mentalHealth.claimCode;
    data.infoMentalHealthItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoSexualHealthItems.length > 0) {
    claimCode = expenseLookup.sexualHealth.claimCode;
    data.infoSexualHealthItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoExtraTravelAndAccommodationItems.length > 0) {
    claimCode = expenseLookup.extraTravelAndAccommodation.claimCode;
    data.infoExtraTravelAndAccommodationItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoSearchAndRescueItems.length > 0) {
    claimCode = expenseLookup.searchAndRescue.claimCode;
    data.infoSearchAndRescueItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoUrgentCareOutOfHoursVisitsItems.length > 0) {
    claimCode = expenseLookup.urgentCareOutOfHoursvisits.claimCode;
    data.infoUrgentCareOutOfHoursVisitsItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoPrescriptionsItems.length > 0) {
    claimCode = expenseLookup.prescriptions.claimCode;
    data.infoPrescriptionsItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoGPVisitsItems.length > 0) {
    claimCode = expenseLookup.GPVisits.claimCode;
    data.infoGPVisitsItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoRehabilitationAndOccupationalTherapyItems.length > 0) {
    claimCode = expenseLookup.rehabilitationAndOccupationalTherapy.claimCode;
    data.infoRehabilitationAndOccupationalTherapyItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoMaternityCareItems.length > 0) {
    claimCode = expenseLookup.maternityCare.claimCode;
    data.infoMaternityCareItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoReplacementStaffItems.length > 0) {
    claimCode = expenseLookup.replacementStaff.claimCode;
    data.infoReplacementStaffItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoRepatriationBenefitItems.length > 0) {
    claimCode = expenseLookup.repatriationBenefit.claimCode;
    data.infoRepatriationBenefitItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoOtherMedicalExpensesItems.length > 0) {
    claimCode = expenseLookup.otherMedicalExpenses.claimCode;
    data.infoOtherMedicalExpensesItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.wereYouHospitalisedForMoreThanThreeDays !== '' && data.infoMedicalExpensesHospitalisedItems.length > 0) {
    claimCode = data.wereYouHospitalisedForMoreThanThreeDays === 'true'
                ? expenseLookup.wereYouHospitalisedForMoreThanThreeDaysYes.claimCode
                : expenseLookup.wereYouHospitalisedForMoreThanThreeDaysNo.claimCode;
    data.infoMedicalExpensesHospitalisedItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  if (data.infoMedicalExpensesCompanionItems.length > 0) {
    claimCode = expenseLookup.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWerehospitalised.claimCode;
    data.infoMedicalExpensesCompanionItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  return expenses;
}

function mapToDentalExpenses(data) {
  if (data.infoDentalExpensesItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.dentalExpenses.claimCode;
  const expenses = [];

  data.infoDentalExpensesItems.forEach(
    (item) => {
      const expense = mapExpenseItem(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );

  return expenses;
}

function mapToFuneralExpenses(data) {
  if (data.infoFuneralExpensesItems.length < 1 && data.infoTheDeathCausedByAnInjuryItems.length < 0 ) {
    return [];
  }
  let claimCode = expenseLookup.funeralExpenses.claimCode;
  const expenses = [];

  data.infoFuneralExpensesItems.forEach(
    (item) => {
      const expense = mapExpenseItem(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );

  if (data.wasTheDeathCausedByAnInjury === 'true' && data.infoTheDeathCausedByAnInjuryItems.length > 0) {
    claimCode = expenseLookup.wasTheDeathCausedByAnInjury.claimCode;
    data.infoTheDeathCausedByAnInjuryItems.forEach(
      (item) => {
        const expense = mapExpenseItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  return expenses;
}

function mapToExpensesArisingFromTerrorism(data) {
  if (data.infoExpensesArisingFromTerrorismItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.expensesArisingFromTerrorism.claimCode;
  const expenses = [];

  data.infoExpensesArisingFromTerrorismItems.forEach(
    (item) => {
      const expense = mapExpenseItem(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );

  return expenses;
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const list = [];
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList;
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))) {
    return list;
  }

  const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
    ? data.whatExpensesAreYouClaimingFor.toJS()
    : data.whatExpensesAreYouClaimingFor || [];

  // Sub-benefits under "Medical & Hospital Expenses" are stored in a separate field
  const subExpensesSelected = !!data.whatAreYourExpensesRelatedTo && typeof data.whatAreYourExpensesRelatedTo.toJS === 'function'
    ? data.whatAreYourExpensesRelatedTo.toJS()
    : data.whatAreYourExpensesRelatedTo || [];

  const isMedicalHospitalExpensesSelected = expensesSelected.includes('Medical & Hospital Expenses');
  const isDentalExpensesSelected = expensesSelected.includes('Dental Expenses');
  const isFuneralExpensesSelected = expensesSelected.includes('Funeral Expenses');
  const isExpensesArisingFromTerrorismSelected = expensesSelected.includes('Expenses arising from terrorism');
  const isExtraTravelAndAccommodationSelected = subExpensesSelected.includes('Extra travel and accommodation');

  const medicalHospitalExpensesCode = expenseLookup.medicalHospitalExpenses.claimCode;
  const accompanyingPersonCode = expenseLookup.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWerehospitalised.claimCode;
  const funeralExpensesCode = expenseLookup.funeralExpenses.claimCode;
  const lossOfLifeCode = expenseLookup.wasTheDeathCausedByAnInjury.claimCode;
  const extraTravelAndAccommodationCode = expenseLookup.extraTravelAndAccommodation.claimCode;

  const medicalExpenses = isMedicalHospitalExpensesSelected ? mapToOtherExpenses(data) : [];
  const dentalExpenses = isDentalExpensesSelected ? mapToDentalExpenses(data) : [];
  const funeralExpenses = isFuneralExpensesSelected ? mapToFuneralExpenses(data) : [];
  const terrorismExpenses = isExpensesArisingFromTerrorismSelected ? mapToExpensesArisingFromTerrorism(data) : [];

  if (claimTypes !== undefined) {
    claimTypes.forEach((item) => {
      if (item.claimCode === medicalHospitalExpensesCode && (isMedicalHospitalExpensesSelected || isDentalExpensesSelected
        || isExpensesArisingFromTerrorismSelected || isFuneralExpensesSelected)) {
        const allMedicalExpenses = [...medicalExpenses, ...dentalExpenses, ...funeralExpenses, ...terrorismExpenses];
        const benefit = mapClaimExpensesLevelItem(item, 'Medical and evacuation', allMedicalExpenses);
        if (!!benefit) {
          list.push(benefit);
        }
      }
      if (item.claimCode === accompanyingPersonCode && data.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true') {
        const benefit = mapClaimExpensesLevelItem(item, 'Accompanying Person', []);
        if (!!benefit) {
          list.push(benefit);
        }
      }
      if (item.claimCode === funeralExpensesCode && isFuneralExpensesSelected) {
        const benefit = mapClaimExpensesLevelItem(item, 'Funeral expenses or return of mortal remains', funeralExpenses);
        if (!!benefit) {
          list.push(benefit);
        }
      }
      if (item.claimCode === lossOfLifeCode && data.wasTheDeathCausedByAnInjury === 'true') {
        const benefit = mapClaimExpensesLevelItem(item, 'Loss Of Life', []);
        if (!!benefit) {
          list.push(benefit);
        }
      }
      if (item.claimCode === extraTravelAndAccommodationCode && isExtraTravelAndAccommodationSelected) {
        const benefit = mapClaimExpensesLevelItem(item, 'Extra travel and accommodation', []);
        if (!!benefit) {
          list.push(benefit);
        }
      }
    });
  }

  return list;
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalAndEvacuationSCTIDataMapper.js